import axios from "axios";
import { baseUrl } from "../apiUrl";
import { buildQueryString, QueryParam } from "../queryUtils";
import { ChangeTask, ChangeTasks } from "./types";



export const getChangeTasks = async (query: QueryParam): Promise<ChangeTasks> => {
       try {
              const response = await axios.get<ChangeTasks>(`${baseUrl}/clo-cms/change/tasks?${buildQueryString(query)}`);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to fetch Change Tasks: ${error}`);
       }
};

export const createChangeTasks = async (changeTasks: Partial<ChangeTask>): Promise<ChangeTask> => {
       try {
              const response = await axios.post<ChangeTask>(`${baseUrl}/clo-cms/change/tasks`, changeTasks);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to create Change Tasks: ${error}`);
       }
};


export const updateChangeTasks = async (changeTasks: Partial<ChangeTask>): Promise<ChangeTask> => {
       try {
              const response = await axios.patch<ChangeTask>(`${baseUrl}/clo-cms/change/tasks`, changeTasks);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to update Change Tasks: ${error}`);
       }
};



